import React, { useState } from "react";
import { Popover, Button, Group } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import useStyles from "./style";
import moment from "moment";
import { MdOutlineCalendarToday } from "react-icons/md";
import { useMediaQuery } from "@mantine/hooks";

const DashboardDateComponent = ({
  dateRange,
  setDateRange,
  handleApply,
  open,
  opened,
  close,
}) => {
  const { classes } = useStyles();
  const isExtraSmallScreen = useMediaQuery("(max-width: 834px)");
  const isMediumScreen = useMediaQuery("(max-width:992px)");
  const [isDateRangeValid, setIsDateRangeValid] = useState(true);

  const handleRange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const startOfDay = new Date(dates[0]).setHours(0, 0, 0, 0);
      const endOfDay = new Date(dates[1]).setHours(23, 59, 59, 999);

      const adjustedDates = [new Date(startOfDay), new Date(endOfDay)];

      setDateRange({ type: "custom", date: adjustedDates });
      setIsDateRangeValid(true);
    } else {
      setDateRange({ type: "custom", date: dates });
      setIsDateRangeValid(false);
    }
  };

  const handleToday = () => {
    let today = new Date();
    const startOfDay = new Date(today.setHours(0, 0, 0, 0));
    const endOfDay = new Date(today.setHours(23, 59, 59, 999));
    setDateRange({
      type: "today",
      date: [startOfDay, endOfDay],
    });
  };

  const handleYesterday = () => {
    let yesterday = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24);
    const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
    const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
    setDateRange({
      type: "yesterday",
      date: [startOfYesterday, endOfYesterday],
    });
  };

  const handleThisMonth = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let firstDay = new Date(year, month, 1);
    let lastDay = new Date(year, month + 1, 0);
    setDateRange({ type: "this month", date: [firstDay, lastDay] });
  };

  const handleLastMonth = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() - 1;
    let firstDay = new Date(year, month, 1);
    let lastDay = new Date(year, month + 1, 0);
    setDateRange({ type: "last month", date: [firstDay, lastDay] });
  };

  const handleThisYear = () => {
    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);
    const lastDayOfYear = new Date(currentYear, 11, 31);
    setDateRange({ type: "this year", date: [firstDayOfYear, lastDayOfYear] });
  };

  const handleCustomRange = () => {
    setIsDateRangeValid(false);
    setDateRange({ type: "custom", date: [] });
  };

  const handleClose = () => {
    setDateRange({ type: "", date: [] });
    setIsDateRangeValid(true);
    close();
  };

  const isActive = (type) => dateRange.type === type;

  return (
    <Group justify="end">
      <Popover
        shadow="md"
        onClose={close}
        opened={opened}
        width={isExtraSmallScreen ? 310 : 450}
        position={isMediumScreen ? "bottom" : "left"}
        middlewares={{ flip: false, shift: false, inline: false }}
      >
        <Popover.Target>
          <Button className={classes.buttonStyle} onClick={open}>
            <MdOutlineCalendarToday className={classes.iconCalendar} />
            {`${
              dateRange?.date[0] === "Select Date"
                ? "Select Date"
                : moment(dateRange?.date[0]).format("ll")
            } - ${
              dateRange?.date[1] === "Select Date"
                ? "Select Date"
                : moment(dateRange?.date[1]).format("ll")
            }`}
          </Button>
        </Popover.Target>
        <Popover.Dropdown className={classes.popOverCard}>
          <div className={classes.datePickerParent}>
            <div className={classes.buttonsParent}>
              <Button
                onClick={() => handleToday()}
                className={`${classes.dateButtons} ${
                  isActive("today") ? classes.activeButton : ""
                }`}
              >
                Today
              </Button>
              <Button
                onClick={() => handleYesterday()}
                className={`${classes.dateButtons} ${
                  isActive("yesterday") ? classes.activeButton : ""
                }`}
              >
                Yesterday
              </Button>
              <Button
                onClick={() => handleThisMonth()}
                className={`${classes.dateButtons} ${
                  isActive("this month") ? classes.activeButton : ""
                }`}
              >
                This month
              </Button>
              <Button
                onClick={() => handleLastMonth()}
                className={`${classes.dateButtons} ${
                  isActive("last month") ? classes.activeButton : ""
                }`}
              >
                Last month
              </Button>
              <Button
                onClick={() => handleThisYear()}
                className={`${classes.dateButtons} ${
                  isActive("this year") ? classes.activeButton : ""
                }`}
              >
                This Year
              </Button>
              <Button
                className={`${classes.dateButtons} ${
                  isActive("custom") ? classes.activeButton : ""
                }`}
                onClick={() => {
                  handleCustomRange();
                }}
              >
                Custom
              </Button>
            </div>
            <div className={classes.datePickerParentDiv}>
              <DatePicker
                type="range"
                maxDate={new Date()}
                onChange={handleRange}
                value={dateRange?.date}
                label="Select dates range"
                placeholder="Select dates range"
                className={classes.datePicker}
              />
              <div className={classes.bottomButtonsParent}>
                <Button
                  onClick={handleClose}
                  className={`${classes.bottomButtons} ${classes.cancelButton}`}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApply}
                  disabled={!isDateRangeValid}
                  className={`${classes.bottomButtons} ${classes.applyButton}`}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};

export default DashboardDateComponent;
